import {
  CheckInvestmentRulesConfirmation,
  GetInvestmentBuyList,
  GetInvestmentFixedCancel,
  GetInvestmentFixedClose,
  GetInvestmentFixedCurrentlyInfo,
  GetInvestmentFixedCurrentlyList,
  GetInvestmentPortfolioBuyAmountMax,
  GetInvestmentPortfolioCancel,
  GetInvestmentPortfolioClose,
  GetInvestmentPortfolioCurrentlyInfo,
  GetInvestmentPortfolioCurrentlyList,
  GetInvestmentPortfolioHistoryForm,
  GetInvestmentPortfolioHistoryList,
  GetInvestmentPortfolioRequestHistoryForm,
  GetInvestmentPortfolioRequestHistoryList,
  GetPortfolioChartList,
  GetPortfolioChartPartialList,
  GetUnitTradeChartList,
  InvestmentFixedCancel,
  InvestmentFixedClose,
  InvestmentPortfolioBuy,
  InvestmentPortfolioCancel,
  InvestmentPortfolioClose,
} from "./api";

import http from "config/http";

const investmentApi = {
  getInvestmentPortfolioCurrentlyInfo: async () =>
    await http.get(GetInvestmentPortfolioCurrentlyInfo),

  getInvestmentFixedCurrentlyInfo: async () =>
    await http.get(GetInvestmentFixedCurrentlyInfo),

  getInvestmentPortfolioCurrentlyList: async () =>
    await http.get(GetInvestmentPortfolioCurrentlyList),

  getInvestmentFixedCurrentlyList: async () =>
    await http.get(GetInvestmentFixedCurrentlyList),

  getInvestmentPortfolioCancel: async (id) =>
    await http.get(GetInvestmentPortfolioCancel(id)),

  getInvestmentFixedCancel: async (id) =>
    await http.get(GetInvestmentFixedCancel(id)),

  investmentPortfolioCancel: async (body) =>
    await http.post(InvestmentPortfolioCancel, body),

  investmentFixedCancel: async (body) =>
    await http.post(InvestmentFixedCancel, body),

  getInvestmentFixedClose: async (id) =>
    await http.get(GetInvestmentFixedClose(id)),

  investmentFixedClose: async (body) =>
    await http.post(InvestmentFixedClose, body),

  getInvestmentBuyList: async () => await http.get(GetInvestmentBuyList),

  investmentPortfolioClose: async (body) =>
    await http.post(InvestmentPortfolioClose, body),

  investmentPortfolioBuy: async (body) =>
    await http.post(InvestmentPortfolioBuy, body),

  getInvestmentPortfolioClose: async (id) =>
    await http.get(GetInvestmentPortfolioClose(id)),

  getInvestmentPortfolioBuyAmountMax: async (id) =>
    await http.get(GetInvestmentPortfolioBuyAmountMax(id)),

  getInvestmentPortfolioHistoryForm: async () =>
    await http.get(GetInvestmentPortfolioHistoryForm),

  getInvestmentPortfolioHistoryList: async ({
    portfolioId,
    startDateInvestmentStart,
    endDateInvestmentStart,
    startDateInvestmentEnd,
    pageNumber,
    pageSize,
  }) =>
    await http.get(
      GetInvestmentPortfolioHistoryList({
        portfolioId,
        startDateInvestmentStart,
        endDateInvestmentStart,
        startDateInvestmentEnd,
        pageNumber,
        pageSize,
      })
    ),

  getPortfolioChartPartialList: async ({ id, coin, endDate, startDate }) => await http.get(GetPortfolioChartPartialList({ id, coin, endDate, startDate })),

  getInvestmentPortfolioRequestHistoryForm: async () =>
    await http.get(GetInvestmentPortfolioRequestHistoryForm),

  getPortfolioChartList: async (id) =>
    await http.get(GetPortfolioChartList(id)),

  checkInvestmentRulesConfirmation: async () =>
    await http.get(CheckInvestmentRulesConfirmation),

  getInvestmentPortfolioRequestHistoryList: async ({
    coinId,
    portfolioId,
    startDate,
    endDate,
    sideId,
    pageNumber,
    pageSize
  }) =>
    await http.get(
      GetInvestmentPortfolioRequestHistoryList({
        coinId,
        portfolioId,
        startDate,
        endDate,
        sideId,
        pageNumber,
        pageSize
      })
    ),

  getUnitTradeChartList: async (id) =>
    await http.get(GetUnitTradeChartList(id)),
};

export default investmentApi;
